import { Box, Heading } from '@zillow/constellation-10';
import { ModalActions } from './PropertySection';

const CONTENT = {
  TITLE: 'Your rental',
} as const;

type EmptyHeaderProps = {
  isLoggedIn: boolean;
  hasMultipleRentals: boolean;
  viewRentalsModal?: React.ReactNode;
  addRentalModal?: React.ReactNode;
};

const EmptyHeader = ({ isLoggedIn, hasMultipleRentals, viewRentalsModal, addRentalModal }: EmptyHeaderProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Heading data-testid="Header-Title" fontFamily="heading" level={1}>
        {CONTENT.TITLE}
      </Heading>
      {isLoggedIn && (
        <ModalActions
          hasMultipleRentals={hasMultipleRentals}
          viewRentalsModal={viewRentalsModal}
          addRentalModal={addRentalModal}
        />
      )}
    </Box>
  );
};

export default EmptyHeader;
